import { BUTTON_PRESS } from './baseEvents'

const QUICK_REPORT_SETTINGS = 'Quick Report - Settings'

export const QUICK_REPORT_DOWNLOAD_QR = `${BUTTON_PRESS} ${QUICK_REPORT_SETTINGS} - Download QR`
export const QUICK_REPORT_DOWNLOAD_FACILITY_QR = `${BUTTON_PRESS} ${QUICK_REPORT_SETTINGS} - Download Facility QR`
